import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EmployeeProfileService {
  constructor(private readonly http: HttpClient) {}

  getEmployeeSearch(search: string) {
    return this.http.get(
      environment.masterDomain +
        '/employee/api/jwtV2/employee/v2/currentEmployeeSearchByKeys?searchCriteria=' +
        encodeURIComponent(search)
    );
  }

  getEmployeeDetails(encryptedId: string) {
    let key = String(encryptedId || '').trim();
    try {
      key = decodeURIComponent(key);
    } catch {
      // keep original if not encoded
    }
    return this.http.get(
      environment.masterDomain +
        '/employee/api/jwtV2/common/empDetails?payrollId=' +
        encodeURIComponent(key)
    );
  }

  getEmployeeImage(payrollId: string) {
    return this.http.get(
      environment.masterDomain +
        '/employee/api/jwtV2/userId/profileImage?payrollId=' +
        encodeURIComponent(payrollId),
      { responseType: 'blob' }
    );
  }

  getBuildingDetails(campusId: string) {
    return this.http.get(
      environment.masterDomain +
        '/apiV2/common/empCmpBuilding?campusId=' +
        encodeURIComponent(campusId)
    );
  }

  /**
   * POST /apiV2/saveEmployeeChangeBuilding?changeBuildingId=<id>&payrollId=<payrollId>
   * payrollId comes from the Payroll Id input on the form.
   */
  saveEmployeeChangeBuilding(changeBuildingId: string, payrollId: string, payload: any = {}) {
    return this.http.post(
      environment.masterDomain +
        '/apiV2/saveEmployeeChangeBuilding?changeBuildingId=' +
        encodeURIComponent(changeBuildingId) +
        '&payrollId=' +
        encodeURIComponent(payrollId),
      payload
    );
  }

  getCurrentBuildingDetails(payrollId: string) {
    return this.http.get(
      environment.masterDomain +
        '/apiV2/common/currentBuildingByPayroll?payrollId=' +
        encodeURIComponent(payrollId)
    );
  }

  getCurrentCampus(payrollId: string) {
    return this.http.get(
      environment.masterDomain + '/apiV2/common/getCampusbyPayrollID?payrollId=' +
      encodeURIComponent(payrollId)
    )
  }
}
